import { IAppState } from '../../common/state';
import { IJournalHighlightsItem } from '../../types/journal';

export function selectJournalHighlights(state: IAppState): IJournalHighlightsItem[] {
  return state.journalHighlights;
}
